import * as React from 'react';
import * as classNames from 'classnames';
import Transition from 'react-transition-group/Transition';
import {SFC} from 'react';
import './styles.sass';

interface IBubbleErrorProps {
  className?: string;
  error: any;
}

const EXITED = 'exited';

export const BubbleError: SFC<IBubbleErrorProps> = ({className, error}) => {
  const visible: boolean = !!error;

  return (
    <Transition
      timeout={{enter: 100}}
      in={visible}
    >
      {(state: string) => {
        if (state === EXITED) {
          return null;
        }

        return (
          <div className={
            classNames('bubble-error-component', className, {[`bubble-error-component_${state}`]: state})
          }>
            {error}
          </div>
        );
      }}
    </Transition>
  );
};

